import app from "./app";
import auth from "./auth";
import edit from "./edit";
import payment from "./payment";
import admin from "./admin";
import autotopup from "./autotopup";

const api = {
    app, auth, edit, payment,admin,autotopup
};
export default api;


